(function () {
    'use strict';

    angular
        .module('hrc.bimiboo.com')
        .controller('DepartmentCtrl', DepartmentCtrl);

    function DepartmentCtrl($scope, $state, $location, $http, AuthenticationService, _env) {

        function getDepartments() {
            $http.get(_env.apiUrl + '/departments').then(function (response) {
                $scope.departments = response.data;
            });
        }

        getDepartments();

        $scope.editDepartment = function (department) {
            var data = {
                title: department && department.title
            };
            Swal.fire({
                title: department ? 'Edit Cost Center' : 'Add Cost Center',
                input: 'text',
                inputValue: data.title,
                inputPlaceholder: 'Type category title here',
                inputValidator: function (value) {
                    if (!value) {
                        return 'You need to write some title!'
                    }
                },
                showCancelButton: true,
                cancelButtonColor: '#d33',
                cancelButtonText: 'Cancel',
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'Save',
                reverseButtons: true
            }).then(function(result) {
                if (result.value && result.value.trim()) {
                    var data = {
                        'title': result.value.trim()
                    };

                    if(department) {
                        $http.put(_env.apiUrl + '/departments/' + department.id, data).then(function(response) {
                            getDepartments();
                        }, function (reason) {
                            Swal.fire({
                                type: 'error',
                                title: 'Oops...',
                                text: JSON.stringify(reason.data, null, 2)
                            });
                        });
                    } else {
                        $http.post(_env.apiUrl + '/departments', data).then(function(response) {
                            getDepartments();
                        }, function (reason) {
                            Swal.fire({
                                type: 'error',
                                title: 'Oops...',
                                text: JSON.stringify(reason.data, null, 2)
                            });
                        });
                    }
                }
            });
        }

        $scope.deleteDepartment = function (department) {
            Swal.fire({
                title: 'Are you sure?',
                text: "You won't be able to revert this!",
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then(function (result) {
                if (result.value) {
                    $scope.proccessing = true;
                    $http.delete(_env.apiUrl + '/departments/' + department.id).then(function () {
                        getDepartments();
                        Swal.fire({
                            type: 'success',
                            title: 'Item successfully deleted',
                            position: 'top-end',
                            timer: 1000
                        });
                    }, function (reason) {
                        Swal.fire({
                            type: 'error',
                            title: 'Oops...',
                            text: JSON.stringify(reason.data, null, 2)
                        });
                    });
                }
            });
        }
    }
})();